import React, { FC } from 'react';
import { IconSVGProps } from '../Icon';

export const LogoIconKit: FC<IconSVGProps> = ({ width = 20, height = 42 }) => (
  <svg
    width="491.61456"
    zoomAndPan="magnify"
    viewBox="0 0 368.71093 145.91594"
    height="194.55458"
    preserveAspectRatio="xMidYMid"
    version="1.0"
    id="svg28"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs id="defs9">
      <g id="g1" />
      <clipPath id="2f3a858a18">
        <path
          d="M 0.433594,0 H 374.56641 V 322.5 H 0.433594 Z m 0,0"
          clipRule="nonzero"
          id="path1"
        />
      </clipPath>
      <clipPath id="da8d88face">
        <path
          d="M 3.144531,149.48047 H 371.85547 v 80.49609 H 3.144531 Z m 0,0"
          clipRule="nonzero"
          id="path2"
        />
      </clipPath>
      <clipPath id="1f7b93ecf5">
        <path
          d="M 3.144531,84.058594 H 27 V 133.5 H 3.144531 Z m 0,0"
          clipRule="nonzero"
          id="path3"
        />
      </clipPath>
      <clipPath id="1737828b75">
        <path
          d="M 29,84.058594 H 54 V 133 H 29 Z m 0,0"
          clipRule="nonzero"
          id="path4"
        />
      </clipPath>
      <clipPath id="5b1f1087ad">
        <path
          d="m 55,84.058594 h 89 V 133.5 H 55 Z m 0,0"
          clipRule="nonzero"
          id="path5"
        />
      </clipPath>
      <clipPath id="9f52e85276">
        <path
          d="m 145,84.058594 h 27 V 133 h -27 z m 0,0"
          clipRule="nonzero"
          id="path6"
        />
      </clipPath>
      <clipPath id="da899a35f3">
        <path
          d="m 174,84.058594 h 24 V 133.5 h -24 z m 0,0"
          clipRule="nonzero"
          id="path7"
        />
      </clipPath>
      <clipPath id="9024714c43">
        <path
          d="m 199,84.058594 h 19 V 133 h -19 z m 0,0"
          clipRule="nonzero"
          id="path8"
        />
      </clipPath>
      <clipPath id="c2930f1253">
        <path
          d="m 219,84.058594 h 25 V 133 h -25 z m 0,0"
          clipRule="nonzero"
          id="path9"
        />
      </clipPath>
    </defs>
    <g
      clipPath="url(#da8d88face)"
      id="g12"
      transform="translate(-3.144531,-84.060618)"
    >
      <path
        fill="#2870ed"
        d="M 3.144531,149.48047 H 371.97656 v 80.49609 H 3.144531 Z m 0,0"
        fillOpacity="1"
        fillRule="nonzero"
        id="path12"
      />
    </g>
    <g
      clipPath="url(#1f7b93ecf5)"
      id="g13"
      transform="translate(-3.144531,-84.060618)"
    >
      <path
        fill="#ffffff"
        d="m 15.292969,84.203125 c -7.320313,0 -11.371094,4.007813 -11.371094,13.640625 v 21.77344 c 0,9.63281 4.050781,13.64062 11.371094,13.64062 7.320312,0 11.371093,-4.00781 11.371093,-13.64062 v -6.39844 H 17.59375 v 5.80078 c 0,4.06641 -0.304688,5.26563 -2.300781,5.26563 -1.996094,0 -2.296875,-1.19922 -2.296875,-5.26563 V 98.441406 c 0,-4.070312 0.300781,-5.265625 2.296875,-5.265625 1.996093,0 2.300781,1.195313 2.300781,5.265625 v 5.800784 h 9.070312 v -6.402346 c 0,-9.628906 -4.050781,-13.640625 -11.371093,-13.640625 z m 0,0"
        fillOpacity="1"
        fillRule="nonzero"
        id="path13"
      />
    </g>
    <g
      clipPath="url(#1737828b75)"
      id="g14"
      transform="translate(-3.144531,-84.060618)"
    >
      <path
        fill="#ffffff"
        d="m 43.945312,104.24219 h -5.6875 V 84.800781 h -9.074218 v 47.859379 h 9.074218 v -19.44141 h 5.6875 v 19.44141 h 9.070313 V 84.800781 h -9.070313 z m 0,0"
        fillOpacity="1"
        fillRule="nonzero"
        id="path14"
      />
    </g>
    <g
      clipPath="url(#5b1f1087ad)"
      id="g15"
      transform="translate(-3.144531,-84.060618)"
    >
      <path
        fill="#ffffff"
        d="m 125.8125,121.13281 c -4.86328,7.23438 -7.54297,8.23828 -8.26953,8.36719 -2.55078,0.44922 -4.48047,-2.46875 -5.46094,-4.48047 -0.46094,-0.9414 -1.07422,-2.3789 -1.64453,-4.29687 3.03125,-4.86328 7.94531,-12.85938 10.16406,-23.56641 1.16407,-5.621094 0.48828,-9.855469 -1.89453,-11.917969 -1.34765,-1.164062 -3.13672,-1.484375 -4.90625,-0.875 -3.58594,1.234375 -6.54687,5.992188 -7.73437,12.414063 -1.88282,10.203126 -1.1211,17.960936 0.24609,23.359376 -3.40234,6.60156 -8.050781,9.11328 -8.925781,9.36328 -2.492188,0.70703 -4.480469,-2.46875 -5.464844,-4.48047 -0.457031,-0.9414 -1.070313,-2.3789 -1.640625,-4.29687 3.039062,-4.88282 7.957031,-12.91016 10.16406,-23.562504 1.16407,-5.625 0.48828,-9.855468 -1.894529,-11.917968 -1.347656,-1.167969 -3.136719,-1.488282 -4.910156,-0.875 -3.582031,1.234374 -6.542969,5.992187 -7.730469,12.414062 -1.886718,10.20313 -1.125,17.96484 0.246094,23.35938 -0.300781,0.69531 -3.785156,8.16406 -7.335938,8.86328 L 73.347656,84.800781 H 60.945312 l -5.929687,47.859379 h 9.074219 l 0.667968,-8.13672 h 4.777344 l 0.664063,8.13672 h 9.074219 c 2.5,-0.28516 6.765624,-4.58594 8.371093,-7.91797 0.292969,0.71875 0.578125,1.35937 0.851563,1.91406 2.664062,5.45703 5.742187,6.77734 8.058594,6.74609 2.65625,-0.0391 6.246092,-1.77734 11.234372,-8.69921 0.29688,0.73437 0.58985,1.38671 0.86719,1.95312 2.66406,5.45703 5.74219,6.74609 8.05859,6.74609 2.63282,0 5.33594,-1.1914 9.10547,-5.82421 v 5.08203 h 17.23828 v -8.97266 h -8.16406 v -10.47266 h 8.16406 v -8.97265 h -8.16406 V 93.773438 h 8.16406 V 84.800781 H 125.82031 V 121.13281 Z M 65.476562,115.55078 67.03125,93.738281 c 0.01172,-0.171875 0.265625,-0.171875 0.273438,0 l 1.5,21.812499 z M 89.652344,97.460938 c 1.207031,-6.515626 3.171875,-9.914063 5.753906,-9.914063 2.035156,0 2.308594,4.007813 1.304688,8.859375 -1.625,7.86328 -4.878907,14.28516 -7.605469,18.94141 -0.675781,-4.57032 -0.808594,-10.54297 0.550781,-17.886722 z m 20.160156,0 c 1.20703,-6.515626 3.50391,-9.832032 5.78516,-9.914063 2.02734,-0.07031 2.27734,4.007813 1.27343,8.859375 -1.63671,7.90234 -4.88281,14.30859 -7.60546,18.94531 -0.67969,-4.5664 -0.8086,-10.54297 0.54687,-17.890622 z m 0,0"
        fillOpacity="1"
        fillRule="nonzero"
        id="path15"
      />
    </g>
    <g
      clipPath="url(#9f52e85276)"
      id="g16"
      transform="translate(-3.144531,-84.060618)"
    >
      <path
        fill="#ffffff"
        d="m 162.82812,108.43359 -7.80078,-23.632809 h -9.07422 v 47.859379 h 9.07422 v -23.62891 l 7.80078,23.62891 h 9.07422 V 84.800781 h -9.07422 z m 0,0"
        fillOpacity="1"
        fillRule="nonzero"
        id="path16"
      />
    </g>
    <g
      clipPath="url(#da899a35f3)"
      id="g17"
      transform="translate(-3.144531,-84.060618)"
    >
      <path
        fill="#ffffff"
        d="m 185.9375,84.203125 c -7.31641,0 -11.37109,4.007813 -11.37109,13.640625 v 21.77344 c 0,9.63281 3.44531,13.64062 9.98046,13.64062 3.26954,0 5.8086,-1.67187 7.6836,-4.00781 l 1.45312,3.41016 h 3.62891 v -24.82813 h -11.37109 v 8.97266 h 2.30078 v 2.21484 c 0,4.06641 -0.30469,5.26563 -2.30078,5.26563 -1.9961,0 -2.29688,-1.19922 -2.29688,-5.26563 V 98.441406 c 0,-4.070312 0.30078,-5.265625 2.29688,-5.265625 1.99609,0 2.30078,1.195313 2.30078,5.265625 v 5.800784 h 9.07031 v -6.402346 c 0,-9.628906 -4.05078,-13.640625 -11.37109,-13.640625 z m 0,0"
        fillOpacity="1"
        fillRule="nonzero"
        id="path17"
      />
    </g>
    <g
      clipPath="url(#9024714c43)"
      id="g18"
      transform="translate(-3.144531,-84.060618)"
    >
      <path
        fill="#ffffff"
        d="m 199.96875,132.66016 h 17.23828 v -8.97266 h -8.16406 v -10.46875 h 8.16406 v -8.97656 h -8.16406 V 93.777344 h 8.16406 v -8.976563 h -17.23828 z m 0,0"
        fillOpacity="1"
        fillRule="nonzero"
        id="path18"
      />
    </g>
    <g
      clipPath="url(#c2930f1253)"
      id="g19"
      transform="translate(-3.144531,-84.060618)"
    >
      <path
        fill="#ffffff"
        d="m 242.73828,128.41406 v -7.41797 c 0,-4.48828 -1.39062,-6.9414 -4.47656,-8.19531 2.84375,-2.03515 4.47656,-5.44531 4.47656,-10.71094 v -4.249996 c 0,-9.628906 -3.44922,-13.039063 -13.79297,-13.039063 H 219.875 v 47.859379 h 9.07031 v -17.52735 c 3.51172,0 4.71875,0.59766 4.71875,4.06641 v 9.21484 c 0,1.79688 0.0586,3.53125 0.66797,4.25 h 9.07031 c -0.60156,-0.71875 -0.66406,-2.45312 -0.66406,-4.25 z m -9.07422,-26.32422 c 0,3.47266 -1.21094,4.07032 -4.71875,4.07032 V 93.777344 c 3.51172,0 4.71875,0.59375 4.71875,4.066406 v 4.25 z m 0,0"
        fillOpacity="1"
        fillRule="nonzero"
        id="path19"
      />
    </g>
    <g
      fill="#292c2e"
      fillOpacity="1"
      id="g22"
      transform="translate(-3.144531,-84.060618)"
    >
      <g transform="translate(14.078018,216.89117)" id="g21">
        <g id="g20">
          <path
            d="M 1.75,-55.921875 H 8.734375 V 0 H 1.75 Z m 25.71875,0 L 15.9375,-27.96875 27.46875,0 h -7.328125 l -11.40625,-27.96875 11.40625,-27.953125 z m 0,0"
            id="path20"
          />
        </g>
      </g>
    </g>
    <g
      fill="#292c2e"
      fillOpacity="1"
      id="g25"
      transform="translate(-3.144531,-84.060618)"
    >
      <g transform="translate(43.297997,216.89117)" id="g24">
        <g id="g23">
          <path
            d="m 5.25,-49.640625 c -1.03125,0 -1.933594,-0.347656 -2.703125,-1.046875 -0.773437,-0.695312 -1.15625,-1.507812 -1.15625,-2.4375 0,-0.976562 0.382813,-1.804688 1.15625,-2.484375 C 3.316406,-56.285156 4.21875,-56.625 5.25,-56.625 c 1.0625,0 1.96875,0.339844 2.71875,1.015625 0.75,0.679687 1.125,1.507813 1.125,2.484375 0,0.929688 -0.375,1.742188 -1.125,2.4375 -0.75,0.699219 -1.65625,1.046875 -2.71875,1.046875 z M 1.75,-45.4375 H 8.734375 V 0 H 1.75 Z m 0,0"
            id="path22"
          />
        </g>
      </g>
    </g>
    <g
      fill="#292c2e"
      fillOpacity="1"
      id="g28"
      transform="translate(-3.144531,-84.060618)"
    >
      <g transform="translate(53.783636,216.89117)" id="g27">
        <g id="g26">
          <path
            d="M 21.328125,-39.140625 H 13.625 v 23.90625 c 0,3.074219 0.242188,5.335937 0.734375,6.78125 0.488281,1.4375 1.785156,2.15625 3.890625,2.15625 h 3.078125 V 0 h -4.34375 C 13.859375,0 11.5625,-0.554688 10.09375,-1.671875 8.632812,-2.796875 7.691406,-4.488281 7.265625,-6.75 c -0.417969,-2.257812 -0.625,-5.085938 -0.625,-8.484375 v -23.90625 H 1.75 V -45.4375 c 2.050781,-0.601562 3.566406,-1.914062 4.546875,-3.9375 0.976563,-2.03125 1.441406,-4.210938 1.390625,-6.546875 h 7 c 0,2.5625 -0.507812,4.835937 -1.515625,6.8125 -1,1.980469 -2.246094,3.203125 -3.734375,3.671875 h 11.890625 z m 0,0"
            id="path25"
          />
        </g>
      </g>
    </g>
  </svg>
);
